<template>
    <tr
      @keydown.esc="cancel"
      @click="startEditMode"
      v-click-outside="doClickOutside"
    >
        <td v-show="editMode">
            <v-autocomplete
                v-model="selectedArticle"
                :items="articles"
                label="Izberi artikel"
                item-text="name"
                ref="name"
                auto-select-first
                return-object
                @change="parseArticleInput"
                @keydown.native="keydownAutocomplete"
                @focus="focusAutocomplete"
                :disabled="saving"
            ></v-autocomplete>
        </td>
        <td v-show="!editMode">{{ selectedArticle ? selectedArticle.name : '' }}</td>

        <td v-show="editMode">
            <v-text-field
                v-model="quantity"
                ref="quantity"
                label="Vnesi količino"
                @keydown="preventLetters"
                @keydown.enter="parseQuantityInput(); save();"
                @keydown.tab.prevent="parseQuantityInput(); save();"
                @focus="$event.target.select()"
                :disabled="saving"
            ></v-text-field>
        </td>
        <td v-show="!editMode">{{ quantity }}</td>

        <td>{{purchase_measurement_unit}}</td>

        <td>{{ price | price}}</td>

        <td>{{ amount | price}}</td>

        <td>{{ taxLevelValue }}%</td>

        <td>{{ taxAmount | price(2) }}&nbsp;€</td>

        <td>{{ valueInclTax | price }}&nbsp;€</td>

        <td v-show="!saving && editMode">
            <ButtonActionSave @click.stop="save" />
            <ButtonActionCloseEditing @click.stop="cancel" />
        </td>
        <td v-show="!saving && !editMode">
          <ButtonActionDelete @click.stop="$emit('delete')" />
        </td>
        <td v-show="saving">
            <v-progress-circular
              :size="20"
              indeterminate
              color="teal"
            ></v-progress-circular>
        </td>
    </tr>
</template>

<script>
import ButtonActionSave from '@/components/ButtonActionSave'
import ButtonActionCloseEditing from '@/components/ButtonActionCloseEditing'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import { parsePrice } from '@/utils/price'
import { parseSiFloat, siFloatToFloat } from '@/utils/number'

export default {
  components: {
    ButtonActionSave,
    ButtonActionCloseEditing,
    ButtonActionDelete
  },
  props: {
    article: {
      default: () => {},
      type: Object
    },
    articles: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      selectedArticle: null,
      quantity: null,
      price: 0,
      amount: 0,
      discount: 0,
      margin: 0,
      marginValue: 0,
      value: 0,
      editMode: false,
      saving: false
    }
  },
  computed: {
    isNewArticle () {
      return this.article ? Object.keys(this.article).length === 0 || !this.article.article : true
    },
    taxLevelValue () {
      return this.selectedArticle ? this.selectedArticle.tax_level_value : 0
    },
    taxAmount () {
      return this.selectedArticle ? this.selectedArticle.tax_amount : 0
    },
    valueInclTax () {
      return this.selectedArticle ? this.selectedArticle.price : 0
    },
    purchase_measurement_unit () {
      return this.selectedArticle ? this.selectedArticle.purchase_measurement_unit_name : ''
    }
  },
  methods: {
    setCurrentRowData (article) {
      let margin = 0
      let marginValue = 0
      if (article && article.margin && article.marginValue) {
        margin = article.margin
        marginValue = article.marginValue
      }
      if (article && article.margin && article.margin_percent) {
        margin = article.margin_percent
        marginValue = article.margin
      }

      this.quantity = article ? article.quantity : null
      this.price = article ? article.price : null
      this.amount = article ? article.amount : null
      this.margin = margin
      this.marginValue = marginValue
      this.discount = article ? article.discount : null
      this.saving = article.saving || false
      this.value = this.calculateValue()
    },
    goTo (refName) {
      this.$refs[refName].focus()
    },
    async save () {
      if (this.selectedArticle && this.selectedArticle.id) {
        this.saving = true
        this.parseAllInputs()
        const saveItem = {
          id: this.isNewArticle ? null : this.article.id,
          article: this.selectedArticle.id,
          quantity: this.quantity,
        }
        const event = this.isNewArticle ? 'save' : 'update'
        this.$emit(event, saveItem)
        this.editMode = false
        this.saving = false
      }
    },
    parseAllInputs () {
      this.parseQuantityInput()
      this.parsePriceInput()
      this.parseDiscountInput()
      this.parseValueInput()
    },
    parseArticleInput () {
    },
    parseQuantityInput () {
      if (!this.quantity) this.quantity = 0
      this.quantity = parseSiFloat(this.quantity, 2)
      if (this.price) {
        this.value = this.calculateValue()
      }
    },
    parsePriceInput () {
      if (!this.price) this.price = 0
      this.price = parsePrice(this.price)
      this.value = this.calculateValue()
    },
    parseDiscountInput () {
      if (!this.discount) this.discount = 0
      this.discount = parseSiFloat(this.discount, 2)
      if (this.discount < 0) this.discount = 0
      if (this.discount > 99) this.discount = 100
      this.value = this.calculateValue()
    },
    // parseMarginInput () {
    //   this.goTo('marginValue')
    // },
    // parseMarginValueInput () {
    //   this.goTo('value')
    // },
    parseValueInput () {
      if (this.quantity) {
        this.price = this.calculatePriceFromValue()
        this.parsePriceInput()
      }
    },
    focusAutocomplete ($event) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          $event.target.select()
        })
      })
    },
    keydownAutocomplete ($event) {
      if ($event.code === 'Enter') {
        this.goTo('quantity')
      }
    },
    calculateValue () {
      const buyingPrice = siFloatToFloat(this.price)
      const discount = siFloatToFloat(this.discount)
      const quantity = siFloatToFloat(this.quantity)
      const discountAmount = (discount / 100) * buyingPrice
      return parsePrice(quantity * (buyingPrice - discountAmount), 2)
    },
    calculatePriceFromValue () {
      const value = siFloatToFloat(this.value)
      const quantity = siFloatToFloat(this.quantity)
      const discount = siFloatToFloat(this.discount)
      const res = (100 * value) / (quantity * (100 - discount))
      return res
    },
    preventLetters ($event) {
      var keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if (keyCode > 64 && keyCode < 91) {
        $event.preventDefault()
      }
    },
    async doClickOutside () {
      if (this.editMode && !this.isNewArticle) {
        await this.save()
        this.editMode = false
      }
    },
    startEditMode () {
      if (!this.editMode) {
        this.editMode = true
        this.$nextTick(() => {
          this.$refs.name.focus()
        })
      }
    },
    stopSaving () {
      this.saving = false
    },
    setStartingArticleFields (article = null) {
      const data = article || this.article
      this.setCurrentRowData(data)
      this.selectedArticle = this.articles.find(article => article.id === data.article)
    },
    cancel (event) {
      if (this.isNewArticle) {
        this.$emit('cancel')
      } else {
        this.editMode = false
        this.setCurrentRowData(this.article)
        this.selectedArticle = this.articles.find(article => article.id === this.article.article)
      }
    }
  },
  mounted () {
    if (!this.isNewArticle) {
      this.setStartingArticleFields()
    } else {
      this.startEditMode()
    }
  }
}
</script>
